import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

   connect() {
    this.contentTarget.classList.add('xs:hidden');
  }

  toggle() {
    if (this.contentTarget.classList.contains('xs:hidden')) {
      this.contentTarget.classList.remove('xs:hidden');
    } else {
      this.contentTarget.classList.add('xs:hidden');
    }
  }
}